import { reporterDomains } from "./reporters.generated.js";
const isCompatible = (query, reporterName) => {
    const selected = (query.select || []).at(0) || "Event";
    const filters = query.filters || [];
    const domain = reporterDomains[reporterName].domain;
    const domainSelect = "select" in domain ? domain.select : null;
    const domainFilters = "filters" in domain ? domain.filters : [];
    // examine the entity types
    // 'domain is everything'
    if (!domainSelect || domainSelect.length === 0)
        return true;
    // if no overlap.
    if (!domainSelect.includes(selected)) {
        // TODO types
        return false;
    }
    // examine the filters.
    // we are looking for disjunction. If the domain are non-disjoint, we deem the reporter compatible
    const compatibility = filters
        .map((f) => {
        const domainFilter = domainFilters.find((df) => df.target == f.target && df.attribute == f.attribute);
        if (domainFilter == null) {
            return true;
        }
        return nonDisjoint(f, domainFilter);
    })
        .reduce((a, b) => a && b, true);
    return compatibility;
};
const nonDisjoint = (a, b) => {
    const aOp = "IN" in a.comparison ? "IN" : "NOT IN";
    const bOp = "IN" in b.comparison ? "IN" : "NOT IN";
    const aValues = a.comparison[aOp];
    const bValues = b.comparison[bOp];
    if (aOp == bOp && aOp == "IN") {
        // if values intersect, then non-disjoint
        return aValues.some((v) => bValues.includes(v));
    }
    else if (aOp == bOp && aOp == "NOT IN") {
        // we assume non-disjoint. Correctness would require checking the set of possible values
        return true;
    }
    else {
        // check that 'NOT IN' does not include all the 'IN'
        const inSet = aOp == "IN" ? aValues : bValues;
        const notInSet = aOp == "NOT IN" ? aValues : bValues;
        return inSet.some((v) => !notInSet.includes(v));
    }
};
export const reportersForQuery = (raw) => {
    const query = raw;
    const candidates = Object.keys(reporterDomains);
    return candidates.filter((reporter) => isCompatible(query, reporter));
};
